import { css } from '@emotion/css';
import { BorderRadiusSize, Color } from 'src/styles';

export const segmented = css`
  border-radius: ${BorderRadiusSize.xs};

  .ant-segmented-item-selected {
    color: white;
    background-color: ${Color.Brand6};
  }

  .ant-segmented-item-selected {
    // border-radius: ${BorderRadiusSize.xs};
  }
`;
